import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-grn-range',
  templateUrl: './grn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class GRNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
